import cloneDeep from 'lodash/cloneDeep';
import pick from 'lodash/pick';
import { IGroupedProps } from './index';
import { EElementType } from '~/src/services/projects';
import templates from '~/src/services/blocks/templates';

const format = (value: any) => {
    if ('string' === typeof value) {
        return value.replace(/ {2,}/g, ' ').trim();
    }
    if ('boolean' === typeof value) {
        return value;
    }
    if (!value) {
        return '';
    }
    return value;
};

export const prepareProperties = (
    properties: Record<string, any>,
    entity: EElementType | string,
    config: Record<string, any>,
): IGroupedProps => {
    const result = {
        key: entity,
        items: [],
        props: {},
        withBreakpoints: false,
    };

    const currConfig = cloneDeep(config[entity]);
    const { renderId = '' } = properties;
    const defaultProps = Object.keys(templates[renderId]?.properties || {});

    const getKeys = (inKey, currConfig, data = {}) => {
        let keys = {};
        const labels = [];

        for (const propKey in currConfig) {
            const configElem = currConfig[propKey];
            const value = data[propKey];
            const key = `${inKey}.${propKey}`;
            const items = configElem?.items;

            if (items) {
                // Из всех настроек для блока, отображаем только те которые есть в tempalte.
                const currItems = inKey === 'block' ? pick(items, defaultProps) : items;

                const { itemsKeys, labels } = getKeys(key, currItems, value);

                keys = {
                    ...keys,
                    ...itemsKeys,
                };

                configElem.items = labels;
            } else {
                keys[key] = format(value);
            }
            configElem.key = key;
            labels.push(configElem);
        }

        return {
            itemsKeys: keys,
            labels,
        };
    };

    const { itemsKeys, labels } = getKeys(entity, currConfig, properties);

    result.items = labels;
    result.props = itemsKeys;

    return result;
};

